var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "用户详情",
        width: "80%",
        visible: _vm.dialogVisible,
        "append-to-body": "",
        fullscreen: _vm.device === "mobile",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
        close: _vm.dialogClose,
      },
    },
    [
      _c(
        "el-tabs",
        {
          staticStyle: { height: "570px" },
          attrs: { "tab-position": "left" },
          model: {
            value: _vm.activeKey,
            callback: function ($$v) {
              _vm.activeKey = $$v
            },
            expression: "activeKey",
          },
        },
        _vm._l(_vm.detailTabs, function (item, index) {
          return _c(
            "el-tab-pane",
            { key: index, attrs: { name: item.name, label: item.title } },
            [
              _c(_vm.getTabComponent(item.name), {
                tag: "component",
                attrs: { "member-id": _vm.memberId },
              }),
            ],
            1
          )
        }),
        1
      ),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.dialogClose } },
            [_vm._v("确 定")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }